var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ui-select',{staticClass:"status-picker",attrs:{"value":_vm.value,"items":_vm.items,"item-text":"text","item-value":"value","prepend-inner-icon":_vm.icon,"autocomplete":false,"hide-details":1},on:{"change":_vm.statusChanged}})}
var staticRenderFns = []

export { render, staticRenderFns }